import baseService from '@/utils/http/axios'
import { message } from 'ant-design-vue'

/**
 * U880电话机 兜底修复完整版
 * 新增主动轮询设备状态，无挂机事件也能自动结束通话
 * 兼容 lParam=0 / "0" / "0L" 挂机值
 * 修复短通话录音空文件问题
 */
const usbphone = {
    state: {
        wsClient: null,
        wsip: 'ws://127.0.0.1:823',
        inp_recordaddr: "",
        tip: [],
        spush: [],

        p_status: 0,
        r_status: 0,
        a_status: 0,
        dv_status: 0,
        icm_flag: 0,
        has_dial: false,
        pre_p_status: 0,

        ringCount: 0,
        incomTimeout: null,
        autoRecordID: null,
        dlyDlokTimeout: null,
        phoneCode: null,
        phoneCodeShow: null,

        serialno: null,
        cnnstate: null,
        messagenum: null,
        inp_phonecode: null,
        inp_serial: null,

        SetLeaveRecordFlag: 0,
        holdTo503: false,
        isDialOnline: false,
        PreDialing: false,

        phone_icm: '',
        audioend: 0,
        rd_icm: false,
        pre_command: '',

        modalVisible: false,
        modalCurentInfo: {
            customer_id: null,
            full_name: '',
            phone: '',
            zipid: null,
            reason: '',
            remark: '',
        },

        callMonitorTimer: null,
        lastMessageTime: Date.now(),
        lastCallEventTime: Date.now(),
        isConnected: false,
    },
    mutations: {
        SET_TIP: (state, tip) => {
            state.tip = tip
        },
        SET_WSCLIENT: (state, wsClient) => {
            state.wsClient = wsClient
        },
        SET_INP_RECORDADDR: (state, inp_recordaddr) => {
            state.inp_recordaddr = inp_recordaddr
        },
        SET_WSIP: (state, wsip) => {
            state.wsip = wsip
        },
        SET_P_STATUS: (state, p_status) => {
            state.p_status = p_status
        },
        SET_R_STATUS: (state, r_status) => {
            state.r_status = r_status
        },
        SET_A_STATUS: (state, a_status) => {
            state.a_status = a_status
        },
        SET_DV_STATUS: (state, dv_status) => {
            state.dv_status = dv_status
        },
        SET_ICM_FLAG: (state, icm_flag) => {
            state.icm_flag = icm_flag
        },
        SET_HAS_DIAL: (state, has_dial) => {
            state.has_dial = has_dial
        },
        SET_PRE_P_STATUS: (state, pre_p_status) => {
            state.pre_p_status = pre_p_status
        },
        SET_RINGCOUNT: (state, ringCount) => {
            state.ringCount = ringCount
        },
        SET_INCOM_TIMEOUT: (state, incomTimeout) => {
            state.incomTimeout = incomTimeout
        },
        SET_AUTORECORDID: (state, autoRecordID) => {
            state.autoRecordID = autoRecordID
        },
        SET_INP_SERIAL: (state, inp_serial) => {
            state.inp_serial = inp_serial
        },
        SET_CNNSTATE: (state, cnnstate) => {
            state.cnnstate = cnnstate
        },
        SET_MESSAGENUM: (state, messagenum) => {
            state.messagenum = messagenum
        },
        SET_PHONECODE: (state, phoneCode) => {
            state.phoneCode = phoneCode
        },
        SET_PHONECODESHOW: (state, phoneCodeShow) => {
            state.phoneCodeShow = phoneCodeShow
        },
        SET_INP_PHONECODE: (state, inp_phonecode) => {
            state.inp_phonecode = inp_phonecode
        },
        SET_SERIALNO: (state, serialno) => {
            state.serialno = serialno
        },
        SET_SPUSH: (state, spush) => {
            state.spush = spush
        },
        SET_SETLEAVERECORDFLAG: (state, SetLeaveRecordFlag) => {
            state.SetLeaveRecordFlag = SetLeaveRecordFlag
        },
        SET_HOLDTO503: (state, holdTo503) => {
            state.holdTo503 = holdTo503
        },
        SET_ISDIALONLINE: (state, isDialOnline) => {
            state.isDialOnline = isDialOnline
        },
        SET_PREDIALING: (state, PreDialing) => {
            state.PreDialing = PreDialing
        },
        SET_PHONE_ICM: (state, phone_icm) => {
            state.phone_icm = phone_icm
        },
        SET_AUDIOEND: (state, audioend) => {
            state.audioend = audioend
        },
        SET_RD_ICM: (state, rd_icm) => {
            state.rd_icm = rd_icm
        },
        SET_PRE_COMMAND: (state, pre_command) => {
            state.pre_command = pre_command
        },
        SET_DLYDLOKTIMEOUT: (state, dlyDlokTimeout) => {
            state.dlyDlokTimeout = dlyDlokTimeout
        },
        SET_MODALVISIBLE: (state, modalVisible) => {
            state.modalVisible = modalVisible
        },
        SET_MODALCURENTINFO: (state, modalCurentInfo) => {
            state.modalCurentInfo = modalCurentInfo
        },
        SET_CALL_MONITOR_TIMER: (state, timer) => {
            state.callMonitorTimer = timer
        },
        SET_LAST_MESSAGE_TIME: (state) => {
            state.lastMessageTime = Date.now()
        },
        SET_LAST_CALL_EVENT_TIME: (state) => {
            state.lastCallEventTime = Date.now()
        },
        SET_IS_CONNECTED: (state, value) => {
            state.isConnected = value
        },
    },
    actions: {
        AddPhoneModal({ commit, state, dispatch }, { phone, customer_id, full_name }) {
            if (state.p_status != 0) {
                if (phone == state.modalCurentInfo.phone) {
                    dispatch('ShowPhoneModal')
                } else {
                    message.error('当前电话正在通话中，请先挂断再拨打')
                }
                return
            }
            commit('SET_MODALCURENTINFO', {
                customer_id: customer_id,
                full_name: full_name,
                phone: phone,
                zipid: null,
                reason: '',
                remark: '',
            })
            commit('SET_MODALVISIBLE', true)
        },
        ShowPhoneModal({ commit }) {
            commit('SET_MODALVISIBLE', true)
        },
        HidePhoneModal({ commit }) {
            commit('SET_MODALVISIBLE', false)
        },

        // 统一挂断：录音延时写盘，解决短通话丢失
        handleAllHangUp({ commit, state, dispatch }) {
            console.log('【统一挂断流程执行】')
            if (state.callMonitorTimer) {
                clearInterval(state.callMonitorTimer);
                commit('SET_CALL_MONITOR_TIMER', null);
            }
            // 先停止录音（内部800ms延时等待硬件写盘）
            dispatch('stopRecorder');
            // 拉长至1200ms，等录音文件完全落地再下发挂断指令
            setTimeout(() => {
                dispatch('sentNCommand', { "cmd": "HP_HangUpCtrl", "rid": 4, "para": null });
            }, 1200);
            // 前端状态立刻重置，不等待硬件延时
            commit('SET_PREDIALING', false);
            commit('SET_ISDIALONLINE', false);
            commit('SET_IS_CONNECTED', false);
            const newInfo = { ...state.modalCurentInfo, zipid: null };
            commit('SET_MODALCURENTINFO', newInfo);
            commit('SET_PHONECODE', "");
            commit('SET_PHONECODESHOW', "");
        },

        // 页面点击挂断按钮
        PhoneCallEnd({ dispatch }) {
            console.log('用户点击挂断按钮');
            dispatch('handleAllHangUp');
        },

        // 【新增兜底：主动查询设备摘挂机状态】
        pollPhoneStatus({ state, dispatch }) {
            if (!state.wsClient || state.wsClient.readyState !== WebSocket.OPEN) {
                return;
            }
            // rid=8 查询当前话机手柄状态
            dispatch('sentNCommand', { cmd: "HP_GetPhoneStatus", rid: 8, para: null });
        },

        // 拨号逻辑
        PhoneCall({ commit, state, dispatch }, { phone, zipid }) {
            let now = new Date();
            let year = now.getFullYear();
            let month = String(now.getMonth() + 1).padStart(2, '0');
            let day = String(now.getDate()).padStart(2, '0');
            let hours = String(now.getHours()).padStart(2, '0');
            let minutes = String(now.getMinutes()).padStart(2, '0');
            let seconds = String(now.getSeconds()).padStart(2, '0');

            let folder = `${year}${month}`;
            let dateTimeStr = year + month + day + hours + minutes + seconds;
            let cleanPhone = String(phone).replace(/\D/g, '');
            let cleanZipid = String(zipid).replace(/\D/g, '');
            let fileName = `${cleanPhone}_${cleanZipid}_${dateTimeStr}.wav`;
            let wavpath = `D:\\usbphonerecord\\${folder}\\${fileName}`;

            commit('SET_INP_RECORDADDR', wavpath);
            console.log('录音文件路径:', wavpath);

            dispatch('sentNCommand', { "cmd": "HP_OffHookCtrl", "rid": 3, "para": null });

            setTimeout(() => {
                dispatch('sentNCommand', { "cmd": "HP_StartDial", "rid": 5, "para": phone });
                commit('SET_PREDIALING', true);
                setTimeout(() => {
                    dispatch('autoRecord');
                }, 500);

                if (state.callMonitorTimer) {
                    clearInterval(state.callMonitorTimer);
                    commit('SET_CALL_MONITOR_TIMER', null);
                }
                commit('SET_IS_CONNECTED', false);
                let startTime = Date.now();
                let timer = setInterval(() => {
                    // 每3秒主动查询设备状态兜底
                    dispatch('pollPhoneStatus');

                    if (state.r_status === 0) {
                        clearInterval(timer);
                        commit('SET_CALL_MONITOR_TIMER', null);
                        return;
                    }
                    // 检测挂机统一走带延时挂断
                    if (state.p_status === 0) {
                        console.log('定时器检测挂机，执行统一挂断');
                        dispatch('handleAllHangUp');
                        clearInterval(timer);
                        commit('SET_CALL_MONITOR_TIMER', null);
                        return;
                    }
                    // 10分钟兜底挂断
                    const elapsed = Date.now() - startTime;
                    if (state.r_status === 1 && elapsed > 600000) {
                        dispatch('handleAllHangUp');
                        clearInterval(timer);
                        commit('SET_CALL_MONITOR_TIMER', null);
                        commit('SET_P_STATUS', 0);
                    }
                }, 3000);
                commit('SET_CALL_MONITOR_TIMER', timer);
            }, 2000);
        },

        SendMsg({ commit, state, dispatch }) {
            console.log('发送短信', arguments[1].phone, arguments[1].msg)
            dispatch('sentCommand', { "cmd": "HP_SendSmsText", "rid": 25, "paraJson": { "Para": arguments[1].msg, "Num": arguments[1].phone } });
        },

        Connect({ commit, state, dispatch }) {
            dispatch('pushTip', '--')
            let wsip = state.wsip;
            if (wsip == null || wsip == "") {
                dispatch('pushTip', '服务器地址不能为空.')
                return;
            }
            dispatch('pushTip', '开始连接.')
            let wsClient = new WebSocket(wsip);
            commit('SET_WSCLIENT', wsClient)
            const actionDispatch = dispatch;
            wsClient.onopen = function () {
                actionDispatch('judgeConnect')
                actionDispatch('oNreceid');
            }
        },

        oNreceid({ commit, state, dispatch }) {
            const actionDispatch = dispatch;
            state.wsClient.onmessage = function (e) {
                const data = e.data;
                console.log('WS原始消息:', data);
                try {
                    const jsonData = JSON.parse(data);
                    if (jsonData.event === 'HP_MsgEvent') {
                        const type = jsonData.type;
                        if (['503', '504', '514', '515'].includes(type)) {
                            commit('SET_LAST_CALL_EVENT_TIME');
                        }
                    }
                } catch (e) { }
                commit('SET_LAST_MESSAGE_TIME');
                actionDispatch('ExplainCommane', data);
            }
            state.wsClient.onclose = function () {
                console.log('WS连接关闭');
                if (state.r_status === 1) {
                    dispatch('stopRecorder');
                }
                actionDispatch('judgeConnect')
            }
        },

        judgeConnect({ commit, state, dispatch }) {
            let wsClient = state.wsClient;
            if (wsClient.readyState === WebSocket.CONNECTING) {
                dispatch('pushTip', "正在连接");
            } else if (wsClient.readyState === WebSocket.CLOSING) {
                dispatch('pushTip', "正在断开连接");
            } else if (wsClient.readyState === WebSocket.OPEN) {
                dispatch('pushTip', "已连接上：" + wsClient.url + " 可以通讯了");
                dispatch('onDevInit');
            } else if (wsClient.readyState === WebSocket.CLOSED) {
                dispatch('pushTip', "连接已关闭");
                dispatch('reInit');
            }
        },

        onDevInit({ commit, state, dispatch }) {
            dispatch('sentNCommand', { "cmd": "HP_Init", "rid": 1, "para": "0" });
        },

        sentNCommand({ commit, state, dispatch }) {
            let strcommand = upUtils.commandNormal(arguments[1].cmd, arguments[1].rid, arguments[1].para);
            state.wsClient.send(strcommand);
        },
        sentCommand({ commit, state, dispatch }) {
            let strcommand = upUtils.commandFull(arguments[1].cmd, arguments[1].rid, arguments[1].paraJson);
            state.wsClient.send(strcommand);
        },
        rsendCommand({ commit, state, dispatch }) {
            dispatch('pushTip', state.pre_command);
            state.wsClient.send(state.pre_command);
        },

        reInit({ commit, state, dispatch }) {
            if (state.callMonitorTimer) {
                clearInterval(state.callMonitorTimer);
                commit('SET_CALL_MONITOR_TIMER', null);
                console.log('重初始化清理通话定时器');
            }
            commit('SET_P_STATUS', 0);
            commit('SET_R_STATUS', 0);
            commit('SET_A_STATUS', 0);
            commit('SET_DV_STATUS', 0);
            commit('SET_ICM_FLAG', 0);
            commit('SET_PRE_COMMAND', '')
            commit('SET_RD_ICM', false)
            commit('SET_PHONECODE', "");
            commit('SET_PHONECODESHOW', "");
            dispatch('showDialDlg');
            commit('SET_WSCLIENT', null)
        },

        onWSClose({ commit, state, dispatch }) {
            state.wsClient.close();
            dispatch('judgeConnect')
        },
        pushTip({ state }, tip) {
            state.tip.push(tip);
        },
        pushPCS({ commit, state }) {
            commit('SET_SPUSH', []);
            commit('SET_PHONECODESHOW', "");
            commit('SET_INP_PHONECODE', state.phoneCodeShow);
        },
        clearTimeoutF({ commit, state, dispatch }) {
            if (state.incomTimeout != null) {
                clearTimeout(state.incomTimeout);
                commit('SET_INCOM_TIMEOUT', null);
            }
        },
        setP_status({ commit, state, dispatch }, status_temp) {
            commit('SET_PRE_P_STATUS', state.p_status);
            commit('SET_P_STATUS', status_temp);
        },
        showDialDlg({ commit, state, dispatch }) { },
        showUIDialStatus({ commit, state, dispatch }) { },
        autoRecord({ commit, state, dispatch }) {
            var path = state.inp_recordaddr;
            if (!path) {
                console.warn('录音路径为空，无法开启录音');
                return;
            }
            dispatch('sentCommand', {
                "cmd": "HP_StartRecordFile",
                "rid": 16,
                "paraJson": { "type": 1, "Para": path }
            });
        },
        // 核心修复：停止录音延时800ms等待硬件写入磁盘再上传
        stopRecorder({ commit, state, dispatch }) {
            console.log('执行停止录音指令');
            if (state.callMonitorTimer) {
                clearInterval(state.callMonitorTimer);
                commit('SET_CALL_MONITOR_TIMER', null);
            }
            // 下发停止录音
            dispatch('sentCommand', {
                "cmd": "HP_StopRecordFile",
                "rid": 17,
                "paraJson": { "type": 1, "path": "", "user": "", "pawd": "" }
            });
            commit('SET_R_STATUS', 0);
            // 延时800ms，硬件缓冲区落地后再上传
            setTimeout(() => {
                const path = state.inp_recordaddr;
                if (!path) {
                    console.warn('无录音文件路径，跳过上传');
                    return;
                }
                dispatch('sentCommand', {
                    "cmd": "HP_UpLoadFile",
                    "rid": 30,
                    "paraJson": { "remote": "hncs.cskaiyela.com/admin/v1/upload", "localfile": path }
                });
                commit('SET_INP_RECORDADDR', '');
                message.info('录音文件上传完成！');
            }, 800);
        },
        answer_end({ dispatch }) {
            dispatch('handleAllHangUp');
        },
        addInp_phonecode({ commit, state, dispatch }, num) {
            let spush = [...state.spush, num];
            commit('SET_SPUSH', spush);
            commit('SET_PHONECODESHOW', spush.join(""));
            commit('SET_INP_PHONECODE', state.phoneCodeShow)
        },
        dloffHookDelay({ commit, state, dispatch }) {
            dispatch('sentNCommand', { "cmd": "HP_OffHookCtrl", "rid": 3, "para": null });
        },

        // 事件解析 兼容0 / "0" / "0L"
        ExplainCommane({ commit, state, dispatch }, command) {
            try {
                const jsonString = JSON.parse(command);
            } catch (SyntaxError) {
                return;
            }
            const jsonString = JSON.parse(command);
            const event = jsonString.event;
            const ret = jsonString.ret;
            if (event == null && ret == null) return;
            if (event != null) {
                const type = jsonString.type;
                const lParam = jsonString.data.lParam;
                console.log('设备事件 type:', type, 'lParam:', lParam);
                switch (type) {
                    case "501":
                    case "511":
                        commit('SET_ICM_FLAG', type === "511" ? 1 : 0);
                        commit('SET_CNNSTATE', '设备已连接');
                        break;
                    case "512":
                        commit('SET_ICM_FLAG', 1);
                        commit('SET_CNNSTATE', lParam == 1 ? '设备已连接(联机成功)' : '设备已连接(联机不成功)');
                        break;
                    case "502":
                        if (lParam == "0L") {
                            commit('SET_CNNSTATE', '设备已全部断开');
                            if (state.r_status === 1) dispatch('stopRecorder');
                        } else commit('SET_CNNSTATE', '已断开设备');
                        dispatch('onWSClose');
                        break;
                    case "515":
                        commit('SET_LAST_CALL_EVENT_TIME');
                        if (lParam == 1) {
                            message.info('对方已摘机');
                            commit('SET_IS_CONNECTED', true);
                        } else {
                            message.info('对方已挂机');
                            commit('SET_IS_CONNECTED', false);
                        }
                        break;
                    case "516":
                        message.info(lParam == 1 ? '耳机插入' : '耳机拔出');
                        break;
                    case "517":
                        dispatch('pushTip', "知信内容：" + lParam);
                        break;
                    case "518":
                        message.info(lParam);
                        break;
                    // 本机手柄 514
                    case "514":
                        if (lParam == 1) {
                            if (state.ringCount > 0 && state.a_status == 1) {
                                dispatch('sentNCommand', { "cmd": "HP_SetLeaveRecord", "rid": 10, "para": "1" });
                                dispatch('showincomDlg');
                                return;
                            }
                            dispatch('clearTimeoutF');
                            dispatch('setP_status', 1);
                            commit('SET_RINGCOUNT', 0);
                            commit('SET_A_STATUS', 0);
                            dispatch('showDialDlg');
                            commit('SET_INP_PHONECODE', state.phoneCodeShow);
                            if (state.r_status == 1) dispatch('stopRecorder');
                            if (state.autoRecordID) clearTimeout(state.autoRecordID);
                            const autoRecordID = setTimeout(() => {
                                if (state.r_status == 0 && state.inp_recordaddr) dispatch('autoRecord')
                            }, 2000);
                            commit('SET_AUTORECORDID', autoRecordID);
                            dispatch('showUIDialStatus', state.p);
                        } else {
                            dispatch('clearTimeoutF');
                            const hangFlag = lParam === 0 || lParam === "0" || lParam === "0L";
                            if (hangFlag) {
                                console.log('【手柄放回挂机 type514 lParam=', lParam, '】');
                                commit('SET_P_STATUS', 0);
                                dispatch('handleAllHangUp');
                            }
                            commit('SET_RINGCOUNT', 0);
                            commit('SET_A_STATUS', 0);
                            dispatch('pushPCS');
                            commit('SET_PHONECODE', "");
                            commit('SET_PHONECODESHOW', "");
                            dispatch('showDialDlg');
                            commit('SET_INP_PHONECODE', state.phoneCodeShow)
                            dispatch('showUIDialStatus', state.p_status);
                        }
                        break;
                    case "503":
                        if (state.ringCount > 0 && state.a_status == 1) {
                            dispatch('sentNCommand', { "cmd": "HP_SetLeaveRecord", "rid": 10, "para": "1" });
                            dispatch('showincomDlg');
                            return;
                        }
                        dispatch('clearTimeoutF');
                        dispatch('setP_status', 1);
                        commit('SET_RINGCOUNT', 0);
                        commit('SET_A_STATUS', 0);
                        dispatch('showDialDlg');
                        commit('SET_INP_PHONECODE', state.phoneCodeShow)
                        if (state.r_status == 1 && !state.holdTo503) {
                            commit('SET_HOLDTO503', false)
                            dispatch('stopRecorder');
                        }
                        dispatch('showUIDialStatus', state.p_status);
                        break;
                    // 话机终止按键 504
                    case "504":
                        dispatch('clearTimeoutF');
                        const hangFlag = lParam === 0 || lParam === "0" || lParam === "0L";
                        if (hangFlag) {
                            console.log('【物理终止/返回按键挂机 type504 lParam=', lParam, '】');
                            commit('SET_P_STATUS', 0);
                            dispatch('handleAllHangUp');
                            commit('SET_RINGCOUNT', 0);
                            commit('SET_A_STATUS', 0);
                            dispatch('pushPCS');
                            commit('SET_PHONECODE', "");
                            commit('SET_PHONECODESHOW', "");
                        } else {
                            commit('SET_P_STATUS', 2);
                            commit('SET_PREDIALING', false);
                        }
                        dispatch('showDialDlg');
                        commit('SET_INP_PHONECODE', state.phoneCodeShow);
                        dispatch('showUIDialStatus', state.p_status);
                        commit('SET_HOLDTO503', false);
                        break;
                    case "505":
                        dispatch('showincomDlg');
                        commit('SET_PHONE_ICM', lParam)
                        commit('SET_PHONECODE', lParam);
                        commit('SET_PHONECODESHOW', lParam);
                        dispatch('clearTimeoutF');
                        break;
                    case "506":
                        let tempLParam = lParam;
                        if (state.icm_flag == 1) {
                            tempLParam = 0;
                            commit('SET_RINGCOUNT', 2);
                        }
                        if (tempLParam != 1) {
                            commit('SET_RINGCOUNT', state.ringCount + 1);
                            if (state.ringCount >= 2) {
                                dispatch('showincomDlg');
                                dispatch('clearTimeoutF');
                                const incomTimeout = setTimeout(() => dispatch('incomTimeoutF'), 5000);
                                commit('SET_INCOM_TIMEOUT', incomTimeout);
                                if (state.ringCount == 3) {
                                    const dlyDlokTimeout = setTimeout(() => dispatch('dloffHookDelay'), 1000);
                                    commit('SET_DLYDLOKTIMEOUT', dlyDlokTimeout);
                                }
                            }
                        } else {
                            commit('SET_RINGCOUNT', 0);
                            dispatch('setP_status', 0);
                            commit('SET_A_STATUS', 0);
                            dispatch('pushPCS');
                            if (state.r_status == 1) dispatch('stopRecorder');
                            commit('SET_PHONECODE', "");
                            commit('SET_PHONECODESHOW', "");
                            dispatch('showDialDlg');
                        }
                        break;
                    case "507":
                        if (state.p_status == 0) dispatch('setP_status', 1);
                        if (state.has_dial) {
                            dispatch('pushPCS');
                            commit('SET_HAS_DIAL', false);
                        }
                        const temp = upUtils.deASCII(lParam);
                        if (!state.isDialOnline) dispatch('addInp_phonecode', temp);
                        break;
                    case "508": break;
                    case "509": break;
                    case "510":
                        if (lParam == 0) {
                            commit('SET_HOLDTO503', false)
                            dispatch('setP_status', 1);
                        } else {
                            commit('SET_HOLDTO503', true)
                            dispatch('setP_status', 3);
                        }
                        break;
                    case "519": dispatch('rsendCommand'); break;
                }
            } else {
                const jsonString = JSON.parse(command);
                const ret = jsonString.ret;
                const rid = jsonString.rid;
                const data = jsonString.data;
                const AnswerData = data?.Ret;
                switch (rid) {
                    case 1:
                        if (jsonString.err) {
                            commit('SET_SERIALNO', '设备初始化错误:' + jsonString.err);
                            return;
                        }
                        const p_type = data.PhoneType;
                        commit('SET_ICM_FLAG', p_type === "4G" ? 1 : 0);
                        commit('SET_CNNSTATE', p_type == "4G" ? '设备已连接(联机成功)' : '设备已连接');
                        commit('SET_SERIALNO', "设备串号:" + data.SerialNo);
                        break;
                    case 3:
                        if (AnswerData == "0") {
                            dispatch('setP_status', 1);
                            dispatch('showUIDialStatus', state.p_status);
                        }
                        break;
                    case 4:
                    case 26:
                        if (AnswerData == "0") {
                            dispatch('setP_status', 0);
                            commit('SET_A_STATUS', 0);
                            if (state.r_status == 1) dispatch('stopRecorder');
                            dispatch('pushPCS');
                            commit('SET_PHONECODE', "");
                            commit('SET_PHONECODESHOW', "");
                            dispatch('clearTimeoutF');
                            dispatch('showUIDialStatus', state.p_status);
                        }
                        break;
                    case 5:
                        if (AnswerData == "0") {
                            commit('SET_A_STATUS', 0);
                            if (state.has_dial) {
                                dispatch('pushPCS');
                                commit('SET_HAS_DIAL', false);
                            }
                            dispatch('clearTimeoutF');
                        }
                        break;
                    // rid=8 主动查询设备状态返回
                    case 8:
                        switch (AnswerData) {
                            case "0":
                                commit('SET_PHONECODE', "");
                                commit('SET_PHONECODESHOW', "");
                                dispatch('setP_status', 0);
                                // 查询到挂机，直接执行挂断
                                if (state.r_status === 1) {
                                    console.log('轮询查询设备为挂机，执行挂断');
                                    dispatch('handleAllHangUp');
                                }
                                break;
                            case "1": dispatch('setP_status', 1); break;
                            case "2": dispatch('setP_status', 3); break;
                            case "3": dispatch('setP_status', 1); break;
                        }
                        dispatch('showUIDialStatus', state.p_status);
                        break;
                    case 16:
                        if (AnswerData == "0") {
                            commit('SET_R_STATUS', 1);
                            console.log('录音启动成功');
                        } else message.error(`录音失败 错误码${AnswerData}`);
                        break;
                    case 17:
                        commit('SET_R_STATUS', 0);
                        commit('SET_A_STATUS', 0);
                        if (AnswerData != "0") message.info("停止录音失败");
                        break;
                    case 30:
                        AnswerData == "0" ? message.success('录音上传成功') : message.error('录音上传失败');
                        break;
                    case 25:
                        message.success(AnswerData == 0 ? "短信发送成功" : "短信发送失败");
                        break;
                }
            }
        },
        incomTimeoutF({ commit, state, dispatch }) {
            commit('SET_PHONECODE', "");
            commit('SET_PHONECODESHOW', "");
            dispatch('showDialDlg');
        },
        NotSendStopREvent() { },
        showincomDlg() { }
    },
    namespaced: true
}

// 工具函数
const upUtils = {
    commandNormal: function (cmd, rid, Para) {
        const jsonp = Para !== null ? { "Para": Para } : {};
        return JSON.stringify({ "req": cmd, "rid": rid, "para": jsonp });
    },
    commandFull: function (cmd, rid, paraJson) {
        return JSON.stringify({ "req": cmd, "rid": rid, "para": paraJson });
    },
    deASCII: function (num) {
        const map = { 48: '0', 49: '1', 50: '2', 51: '3', 52: '4', 53: '5', 54: '6', 55: '7', 56: '8', 57: '9', 35: '#', 42: '*' };
        return map[num] || null;
    }
}
export default usbphone
